export class InvalidViewError extends Error {
    constructor(message, view) {
        super(message);
        this.view = view;
    }
}
//# sourceMappingURL=errors.js.map